// extracted by mini-css-extract-plugin
module.exports = {"photo":"member-list_photo__2oUtx","name":"member-list_name__1iaE9","email":"member-list_email__18e6Q","you":"member-list_you__ExMpx","cost":"member-list_cost__2Yv9a"};